// Hook do tworzenia oferty – POST /sales-crm/offers

import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError, ICommandResponseSuccess } from 'api/types';

export interface IPostSalesCrmOfferRequest {
  client_id: number;
  number: string;
  status?: number | null;
  // Id typu oferty ze slownika sales_crm_offer_type (opcjonalne).
  offer_type_id?: number | null;
}

type IResponse = ICommandResponseSuccess;

const postSalesCrmOffer = (data: IPostSalesCrmOfferRequest): Promise<IResponse> =>
  axios.post('/sales-crm/offers', data);

export const usePostSalesCrmOffer = (
  options?: UseMutationOptions<IResponse, IError, IPostSalesCrmOfferRequest>
) => useMutation((data: IPostSalesCrmOfferRequest) => postSalesCrmOffer(data), options);
